import { type MouseEventHandler } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { motion, type HTMLMotionProps } from 'motion/react';

type Props = Omit<HTMLMotionProps<'tr'>, 'onClick'> & { disableHoverStyle?: boolean } & (
    | { href?: undefined; forceNewTab?: undefined; onClick: MouseEventHandler<HTMLTableRowElement> }
    | { href: string; forceNewTab?: boolean; onClick?: undefined }
  );

const ClickableTableRow: React.FC<Props> = ({
  disableHoverStyle,
  onClick,
  children,
  forceNewTab,
  href,
  ...props
}) => {
  const router = useRouter();

  return (
    <motion.tr
      {...props}
      className={classNames(
        !disableHoverStyle &&
          'transition:ease-in duration-150 hover:cursor-pointer hover:bg-cf-gray-3-5',
        props.className,
      )}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        } else if (e.ctrlKey || e.metaKey || forceNewTab || href.startsWith('http')) {
          window.open(href, '_blank');
        } else {
          router.push(href);
        }
      }}
      onAuxClick={(e) => {
        if (href && e.button === 1) {
          window.open(href, '_blank');
        }
      }}
    >
      {children}
    </motion.tr>
  );
};

export default ClickableTableRow;
